// Author Liang Gang Qiang
// Date 2022-03-14 16:21:35

import * as model from "@/model/sithMes/prd/SithMesPrdToolsRelateOperationModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdToolsRelateOperation(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .buildStore()
